const authenticate = (payload) => {
    return {
        type: 'authenticate',
        payload
    }
}

export { authenticate }